import clsx from 'clsx';

import { IM190BrandOverviewModule } from '~/lib/data-contract';
import { SkipLink } from '~/shared/components/SkipLink/SkipLink';
import { useModuleColors } from '~/theme';

import { M190Content } from './components/M190Content/M190Content';
import { M190LogoWall } from './components/M190LogoWall/M190LogoWall';
import { M190Stories } from './components/M190Stories/M190Stories';
import styles from './m190BrandOverviewStories.module.css';

export type M190BrandOverviewStoriesProps = IM190BrandOverviewModule;

export const M190BrandOverviewStories = ({ brands, headline, text, shopAllCallToAction, moduleBackgroundColor, items, anchorId }: M190BrandOverviewStoriesProps) => {
	const { backgroundColor } = useModuleColors(moduleBackgroundColor);

	return (
		<div
			className={clsx(styles.root, !!backgroundColor && styles.withBackground)}
			id={anchorId?.toLowerCase()}
			style={{ backgroundColor }}
		>
			<SkipLink />
			<M190LogoWall brands={brands} />
			<div className={styles.storyGrid}>
				<M190Content
					headline={headline}
					text={text}
					shopAllCallToAction={shopAllCallToAction}
				/>
				<M190Stories items={items} />
			</div>
		</div>
	);
};
